<template>
  <router-view />
</template>

<script>
export default {
name: "NestOne"
}
</script>

<style scoped>

</style>